<template>
  <div>



    <b-row>
      <b-col md="12">

        <b-card>
          <b-row class="pt-sm-1">
            <b-col sm="1">
              <span class="card-title wise-card-title">검색 조건</span>
            </b-col>
            <b-col sm="1"><strong>매출기간</strong></b-col>
            <b-col sm="3">
              <date-picker v-model="fullDate"
                           type="date"
                           style="width: 100%;"
                           range
                           placeholder="조회기간 선택"
                           :lang="datepickerLang"/>
            </b-col>
            <b-col sm="6">
              <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
              <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
              <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
              <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
              <button type="button" class="btn btn-outline-primary"s style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
            </b-col>


          </b-row>

          <b-row  class="pt-sm-2">
            <b-col sm="1"></b-col>
            <b-col sm="1"><strong>상품구분</strong></b-col>
            <b-col sm="5" style="display: inline-flex;">
              <b-form-radio-group id="product-group" v-model="queryParams.sales_product_type" v-on:change="queryParams.pay_ar_type = 'all'" :options="salesProductOptions" name="product-options"></b-form-radio-group>
            </b-col>
          </b-row>


          <b-row  class="pt-sm-2" v-show="queryParams.sales_product_type == 'AUP'">
            <b-col sm="1"></b-col>
            <b-col sm="1"><strong>판매구분</strong></b-col>
            <b-col sm="5" style="display: inline-flex;">
              <b-form-radio-group id="payar-group" :disabled="queryParams.sales_product_type != 'AUP'" v-model="queryParams.pay_ar_type" :options="payArOptions" name="payar-options"></b-form-radio-group>
            </b-col>
          </b-row>

          <b-row  class="pt-sm-2">
            <b-col sm="1"></b-col>
            <b-col sm="1"><strong>결제구분</strong></b-col>
            <b-col sm="8" style="display: inline-flex;">
              <b-form-radio-group id="payorder-group" v-model="queryParams.pay_order_type" :options="payOrderOptions" name="payorder-options"></b-form-radio-group>
            </b-col>
            <b-col sm="2" style="text-align: center;">
              <b-button variant="primary" style="width: 100%;" v-on:click="salesStatisticsTotalInfo(); findSalesStatisticsList()">검색</b-button>
            </b-col>
          </b-row>
          <!-- 활성화 END -->
        </b-card>
      </b-col>

      <b-col md="12">
        <b-card>

          <b-row>
            <b-col sm="12">
              <span class="card-title wise-card-title">총 매출 현황</span>
            </b-col>
          </b-row>
          <div>
            <table id="__BVID__2714" aria-busy="false" aria-colcount="4" aria-rowcount="-1" class="table b-table table-striped">
              <thead class="" style="background-color:#f1f1f1">
              <tr>
                <th class="text-center" style="vertical-align:middle; border-top:2px solid #a3b6c0; border-right:2px solid #a3b6c0"></th>
                <th class="text-center" style="border-top:2px solid #a3b6c0; border-right:2px solid #a3b6c0">계정상품(일반구매)</th>
                <th class="text-center" style="border-top:2px solid #a3b6c0; border-right:2px solid #a3b6c0">계정상품(관리자지정)</th>
                <th class="text-center" style="border-top:2px solid #a3b6c0; border-right:2px solid #a3b6c0">개별보고서</th>
                <th class="text-center" style="border-top:2px solid #a3b6c0; border-right:2px solid #a3b6c0">종합보고서(파일본)</th>
                <th class="text-center" style="border-top:2px solid #a3b6c0">종합보고서(제책본)</th>
              </tr>
              <tr>
                <th class="text-center" width="80" style="vertical-align:middle; border-right:2px solid #a3b6c0"></th>
                <th class="text-center" width="130" style="border-right:2px solid #a3b6c0">금액</th>
                <th class="text-center" width="130" style="border-right:2px solid #a3b6c0">금액</th>
                <th class="text-center" width="130" style="border-right:2px solid #a3b6c0">금액</th>
                <th class="text-center" width="130" style="border-right:2px solid #a3b6c0">금액</th>
                <th class="text-center" width="130" >금액</th>
              </tr>
              </thead>
              <tbody class="">
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                <td class="text-center" style="border-right:2px solid #a3b6c0"><strong style="font-size:15px">공급가</strong></td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.aup_suppy_total != null ? Number(salesTotalItems.aup_suppy_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>

                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.aup_admin_suppy_total != null ? Number(salesTotalItems.aup_admin_suppy_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>

                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.drp_suppy_total != null ? Number(salesTotalItems.drp_suppy_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>

                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.adf_suppy_total != null ? Number(salesTotalItems.adf_suppy_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>

                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.adb_suppy_total != null ? Number(salesTotalItems.adb_suppy_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>

              </tr>
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                <td class="text-center" style="border-right:2px solid #a3b6c0"><strong style="font-size:15px">VAT</strong></td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.aup_vat_total != null ? Number(salesTotalItems.aup_vat_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.aup_admin_vat_total != null ? Number(salesTotalItems.aup_admin_vat_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.drp_vat_total != null ? Number(salesTotalItems.drp_vat_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.adf_vat_total != null ? Number(salesTotalItems.adf_vat_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px"> - </strong>
                  </div>
                </td>
              </tr>
              <tr class="" style="background-color:#ffffff;text-align:center">
                <td class="text-center" style="border-right:2px solid #a3b6c0;"><strong style="font-size:15px">결제금액</strong></td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.aup_amount_total != null ? Number(salesTotalItems.aup_amount_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.aup_admin_amount_total != null ? Number(salesTotalItems.aup_admin_amount_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.drp_amount_total != null ? Number(salesTotalItems.drp_amount_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.adf_amount_total != null ? Number(salesTotalItems.adf_amount_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>
                <td class="text-center">
                  <div>
                    <strong style="font-size:15px">￦ {{salesTotalItems.adb_amount_total != null ? Number(salesTotalItems.adb_amount_total).toLocaleString() : 0}}</strong>
                  </div>
                </td>
              </tr>
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                <td class="text-center" style="border-right:2px solid #a3b6c0; border-bottom:2px solid #a3b6c0"><strong style="font-size:15px">건수</strong></td>
                <td class="text-center" style="border-bottom:2px solid #a3b6c0">
                  <div>
                    <strong style="font-size:15px">{{salesTotalItems.aup_cnt != null ? Number(salesTotalItems.aup_cnt).toLocaleString() : 0}} 건</strong>
                  </div>
                </td>
                <td class="text-center" style="border-bottom:2px solid #a3b6c0">
                  <div>
                    <strong style="font-size:15px">{{salesTotalItems.aup_admin_cnt != null ? Number(salesTotalItems.aup_admin_cnt).toLocaleString() : 0}} 건</strong>
                  </div>
                </td>
                <td class="text-center" style="border-bottom:2px solid #a3b6c0">
                  <div>
                    <strong style="font-size:15px">{{salesTotalItems.drp_cnt != null ? Number(salesTotalItems.drp_cnt).toLocaleString() : 0}} 건</strong>
                  </div>
                </td>
                <td class="text-center" style="border-bottom:2px solid #a3b6c0">
                  <div>
                    <strong style="font-size:15px">{{salesTotalItems.adf_cnt != null ? Number(salesTotalItems.adf_cnt).toLocaleString() : 0}} 건</strong>
                  </div>
                </td>
                <td class="text-center" style="border-bottom:2px solid #a3b6c0">
                  <div>
                    <strong style="font-size:15px">{{salesTotalItems.adb_cnt != null ? Number(salesTotalItems.adb_cnt).toLocaleString() : 0}} 건</strong>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-card>

        <b-card>
          <b-row>
            <b-col sm="12">
              <b-row>
                <b-col sm="4">
                  <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                  <b-button size="sm" variant="success" v-on:click="excelDownloadForm()" class="exceldown_button"><h5 style="margin-bottom:0px"><i class="fa fa-file-excel-o"></i> 엑셀다운로드</h5></b-button>
                  <span style="color:#8c8872; font-weight:bold; font-size:15px">* 아래 정보를 다운받으실수 있습니다.</span>
                </b-col>
                <b-col sm="3"></b-col>
                <b-col sm="3"></b-col>
                <b-col md="2" class="my-1">
                  <b-form-group label-cols-sm="5" label="" class="mb-0">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col sm="12" class="pt-sm-1 tabledisplay">
              <b-row>
                <b-col sm="1"></b-col>
                <b-col v-if="isLoading" sm="12">
                  <div class="text-center loadingbar" style="margin:100px 0 150px 0">
                    <div style="width:200px; height:100px; margin:0 auto; vertical-align:middle">
                      <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
                      <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
                    </div>
                  </div>
                </b-col>

                <b-col sm="12" v-else>
                  <div style="width:100%">
                    <div style="float:left; text-align:center; width:30%">
                      결제 정보
                    </div>
                    <div style="float:left; text-align:center; width:70%">
                      구매자 정보
                    </div>
                  </div>
                  <b-table
                    ref="totaltable"
                    class="table-responsive"
                    striped
                    hover
                    :fields="fieldItems"
                    :items="items"
                    :busy="items == 0"
                    :current-page="currentPage"
                    :per-page="perPage">
                    <template v-slot:table-busy>
                          <div class="text-center my-2">
                            <strong>데이터가 없습니다.</strong>
                          </div>
                    </template>
                    <template slot="rnum" slot-scope="data">
                      <div style="width:30px">{{data.item.rnum}}</div>
                    </template>
                    <template slot="product_type_name" slot-scope="data">
                      <div style="width:70px" v-html="data.item.product_type_name"></div>
                    </template>
                    <template slot="order_pname" slot-scope="data">
                      <div style="width:120px">{{data.item.order_pname}}</div>
                    </template>
                    <template slot="op_opt_name_groups" slot-scope="data">
                      <div style="width:130px">{{data.item.op_opt_name_groups}}</div>
                    </template>
                    <template slot="order_date" slot-scope="data">
                      <div style="width:80px">{{data.item.order_date}}</div>
                    </template>
                    <template slot="order_payname_or_email" slot-scope="data">
                      <div>{{data.item.order_pay_name}}<br/>{{'('+data.item.email+')'}}</div>
                    </template>
                    <template slot="order_price" slot-scope="data">
                      <div style="width:80px">￦ {{Number(data.item.order_price).toLocaleString()}}</div>
                    </template>
                    <template slot="order_amount" slot-scope="data">
                      <div style="width:80px">￦ {{Number(data.item.order_amount).toLocaleString()}}</div>
                    </template>
                    <template slot="order_supply_price" slot-scope="data">
                      <div style="width:80px">￦ {{Number(data.item.order_supply_price).toLocaleString()}}</div>
                    </template>
                    <template slot="order_vat_price" slot-scope="data">
                      <div style="width:80px">￦ {{Number(data.item.order_vat_price).toLocaleString()}}</div>
                    </template>
                    <template slot="pay_type_name" slot-scope="data">
                      <div style="width:70px" v-html="data.item.pay_type_name"></div>
                    </template>
                    <template slot="recognize_name" slot-scope="data">
                      <div style="width:70px" v-html="data.item.recognize_name"></div>
                    </template>
                    <template slot="price_or_point" slot-scope="data">
                      <div v-show="data.item.sales_type == 'free'">무료</br>(<span style="width:17px; height:17px; background:#fff; font-weight:bold; font-size:10px; text-align:center; color:#ff500f; border-radius:20px; border:2px solid #ff500f; display:inline-block">R</span> {{Number(data.item.report_point_minus).toLocaleString()}})</div>
                      <div v-show="data.item.sales_type == 'pay'">{{viewTypes == 'DOWNLOAD' ? ('￦ '+Number(data.item.r_price).toLocaleString()) : ('￦ '+Number(data.item.min_price).toLocaleString())}}<br/>{{viewTypes == 'DOWNLOAD' ? '' : (' ~ ￦ '+Number(data.item.max_price).toLocaleString())}}<br v-if="viewTypes != 'DOWNLOAD'"/>(<span style="color:#ea0000">{{'구매 : '+(viewTypes == 'DOWNLOAD' ? Number(data.item.in_opt_purchase_cnt).toLocaleString() : Number(data.item.in_purchase_cnt).toLocaleString())}}</span>)</div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" class="pt-sm-1 tabledisplay">
              <b-row class="pb-sm-2">
                <b-col sm="1"></b-col>
                <b-col sm="12" class="my-1">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="listRows"
                    :per-page="perPage"
                    align="center"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import swal from 'sweetalert2'
import SalesSearch from "./component/SalesSearch";
import _ from "lodash";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

const moment = require("moment");

export default {
  components: {
    SalesSearch,
    DatePicker
  },
  data() {
    return {

      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },
      view_type_options: [
        {text: '조회', value: 'VIEW'},
        {text: '추천', value: 'RECOMMAND'},
        {text: '다운로드', value: 'DOWNLOAD'},
        {text: '후속연구요청', value: 'RESEARCH'},
      ],
      fullDateTmp: [],
      fullDate: [],



      viewTypes: 'VIEW',
      searchCheck: false,
      salesProductOptions: [
        {text: '전체',value: 'all'},
        {text: '계정상품',value: 'AUP'},
        {text: '개별보고서',value: 'DRP'},
        {text: '종합보고서(제책본)',value: 'ADB'},
        {text: '종합보고서(파일본)',value: 'ADF'},
      ], // 상품구분 타입
      payArOptions: [
          {text: '전체',value: 'all'},
          {text: '소비자',value: 'PRDT_TYPE_2_1'},
          {text: '영업지원',value: 'PRDT_TYPE_2_2'},
          {text: '내부제공',value: 'PRDT_TYPE_2_3'},
          {text: 'NCP',value: 'PRDT_TYPE_2_4'},
          {text: '기타',value: 'PRDT_TYPE_2_5'},
      ], // 판매구분
      payOrderOptions: [
          {text: '전체',value: 'all'},
          {text: '신용카드',value: 'PAY_TYPE_1'},
          {text: '무통장입금',value: 'PAY_TYPE_2'},
      ], // 결제구분
      // totalRows: 30,
      excelTotalCnt: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      searchData: {},
      queryParams: {
        sales_product_type: 'all',
        pay_ar_type: 'all',
        pay_order_type: 'all',
        day_code: 'dayall',
        start_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      salesTotalItems: {},
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        },
      }, {
        'product_type_name': {
          'label': '상품구분',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        },
        // 'visible': true,
      }, {
        'order_pname': {
          'label': '주문명',
          'thStyle': {
            'vertical-align': 'middle',
            'text-align': 'center'
          }
        }
      }, {
        'op_opt_name_groups': {
          'label': '주문상품옵션',
          'thStyle': {
            'vertical-align': 'middle',
            'text-align': 'center'
          }
        }
      }, {
        'order_date': {
          'label': '주문일',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle',
            'text-align': 'center'
          }
        }
      }, {
        'order_price': {
          'label': '소비자가',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'order_dc_price': {
          'label': '할인가',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'order_amount': {
          'label': '결제금액',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'order_supply_price': {
          'label': '공급가',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'order_vat_price': {
          'label': 'VAT',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'pay_type_name': {
          'label': '결제구분',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'company': {
          'label': '기업명',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'company_category_name': {
          'label': '기업구분',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'order_payname_or_email': {
          'label': '구매자(이메일)',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }
        // , {
        //   'phone': {
        //     'label': '전화번호',
        //     'class': 'text-center',
        //     'thStyle': {
        //        'vertical-align': 'middle'
        //     }
        //   }
        // }, {
        //   'mobile': {
        //     'label': '휴대전화',
        //     'class': 'text-center',
        //     'thStyle': {
        //        'vertical-align': 'middle'
        //     }
        //   }
        // }
        , {
          'recognize_name': {
            'label': '인지경로',
            'class': 'text-center',
            'thStyle': {
              'vertical-align': 'middle'
            }
          }
        }],
      items: [],
      dateMonthButtons: [
        { item_name: '전체', item_code:'dayall', state: true },
        { item_name: '오늘', item_code:'-1|days',state: false },
        { item_name: '1주일', item_code:'-7|days',state: false },
        { item_name: '1개월', item_code:'-1|months',state: false },
        { item_name: '6개월', item_code:'-6|months',state: false },
        { item_name: '1년', item_code:'-1|years',state: false },
      ],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      isLoading: true,
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  watch: {},
  mounted: function() {
    $(".tabledisplay").show();
    // /contents/trendbrief
    this.salesStatisticsInit();
  },
  methods: {

    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },

    dateRange(flag) {
      let endDate;
      let startDate;
      if(this.fullDate.length === 0){
        endDate = new Date();
        startDate = new Date();
      }else{
        endDate = this.fullDate[1];
        startDate = _.clone(this.fullDate[1]);
      }

      if(flag == '1WEEK'){
        startDate.setDate(endDate.getDate() - 7);
      }else if(flag == '1MONTH'){
        startDate.setMonth(endDate.getMonth() - 1);
      }else if(flag == '6MONTH'){
        startDate.setMonth(endDate.getMonth() - 6);
      }else if(flag == '1YEAR'){
        startDate.setFullYear(endDate.getFullYear() - 1);
      }
      this.fullDate = [startDate, endDate];
      if(flag == 'ALL'){
        this.fullDate = [];
      }
    },

    searchOncheck(){
      var self = this;
      if(self.queryParams.sales_product_type != 'all'){
        self.searchCheck = true;
      }
      if(self.queryParams.pay_ar_type != 'all'){
        self.searchCheck = true;
      }
      if(self.queryParams.pay_order_type != 'all'){
        self.searchCheck = true;
      }
      if(self.queryParams.day_code != 'dayall'){
        self.searchCheck = true;
      }

      if(self.queryParams.sales_product_type == 'all' &&
        self.queryParams.pay_ar_type == 'all' &&
        self.queryParams.pay_order_type == 'all'){
        self.searchCheck = false;
      }
    },
    searchReset(){
      var self = this;
      self.queryParams = {
        sales_product_type: 'all',
        pay_ar_type: 'all',
        pay_order_type: 'all',
      };
      self.salesStatisticsTotalInfo();
      self.findSalesStatisticsList();
    },
    salesStatisticsInit() {
      var token = sessionStorage.getItem("myToken");
      var self = this;

      self.searchData = {};
      self.dateMonthButtons.forEach(function (el, idx, arr){
        if(idx == 0){
          el.state = true;
        }else{
          el.state = false;
        }
      });

      self.$store.dispatch('SELECTITEMCODEOPTION', [this, "PRDT_TYPE_2", 3])
        .then(response => {
          var selectItems = response;
          self.payArOptions = [];
          self.payArOptions.push({text: '전체',value: 'all'});
          selectItems.forEach(function (el, idx, arr){
            var items = {
              text: el.item_name,
              value: el.item_code,
            };
            self.payArOptions.push(items);
          });
        }, (error) => {
          console.log(error.response)
        })

      self.$store.dispatch('SELECTITEMCODEOPTION', [this, "PAY_TYPE", 2])
        .then(response => {
          var selectItems = response;
          self.payOrderOptions = [];
          self.payOrderOptions.push({text: '전체',value: 'all'});
          selectItems.forEach(function (el, idx, arr){
            var items = {
              text: el.item_name,
              value: el.item_code,
            };
            self.payOrderOptions.push(items);
          });
        }, (error) => {
          console.log(error.response)
        })

      // if(self.$session.get('queryParamsInfo') != undefined){
      //   self.queryParams = JSON.parse(self.$session.get('queryParamsInfo'));
      // }
      self.salesStatisticsTotalInfo();
      self.findSalesStatisticsList();

      $(function() {
        $('input[name="daterange"]').daterangepicker({
          opens: 'left',
          "locale": self.calendarLocale,
          "endDate": moment().format('YYYY-MM-DD'),
          "startDate": moment().add(-1, 'days').format('YYYY-MM-DD')
        }, function(start, end, label) {
          self.queryParams.start_date = start.format('YYYY-MM-DD');
          self.queryParams.end_date = end.format('YYYY-MM-DD');
        });
      });
    },
    salesStatisticsTotalInfo(){
      var self = this;

      self.queryParams.start_date = this.getFormatDate(this.fullDate[0]);
      self.queryParams.end_date = this.getFormatDate(this.fullDate[1]);

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/salesStatisticsStatusTotal?access_token=' + token, data, null)
        .then((result) => {
          self.salesTotalItems = result.data;
          console.log(self.salesTotalItems);
        })
    },
    // 메소드명 : findSalesStatisticsList()
    // ### 매출 통계 조회 ###
    // 매출의 기본적인 조회수 목록을 DB테이블에서 조회한다.
    //
    // 최초작성 : 2020.07.28
    // 파라미터 :
    //  - parentCode(그룹코드 값)
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜     작성자   수정내용
    // 2020.07.28  황경현   최초작성
    // *************************
    findSalesStatisticsList() {
      $(".tabledisplay").hide();
      var self = this;

      self.queryParams.start_date = this.getFormatDate(this.fullDate[0]);
      self.queryParams.end_date = this.getFormatDate(this.fullDate[1]);
      self.isLoading = true;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/salesStatisticsList?access_token=' + token, data, null)
        .then((result) => {
          self.isLoading = false;
          self.items = result.data.salesStatisticsList;
          self.excelTotalCnt = result.data.excel_total;
          var itemCnt = self.items.length;
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
          });
          $(".tabledisplay").show();
        })
      $(".tabledisplay").show();
      self.searchData.startday = self.queryParams.start_date;
      self.searchData.endday = self.queryParams.end_date;
      self.searchData.dayAllCheck = self.queryParams.day_code == 'dayall';
      self.searchData.product_type_name = (self.salesProductOptions.filter((x) => { return x.value == self.queryParams.sales_product_type; }))[0].text;
      self.searchData.payar_type_name = (self.payArOptions.filter((x) => { return x.value == self.queryParams.pay_ar_type; }))[0].text;
      self.searchData.payorder_type_name = (self.payOrderOptions.filter((x) => { return x.value == self.queryParams.pay_order_type; }))[0].text;

      self.searchOncheck();
    },
    excelDownloadForm(){
      var self = this;
      var authKeyTable = "";
      authKeyTable += '<section class="container_login loginbox" style="margin:0px auto">';
      authKeyTable += '    <dl style="margin-top:32px">';
      authKeyTable += '        <dd>';
      authKeyTable += '            <p style="text-align:center; font-weight:600; font-size:17px">현재 아래의 기준으로 다운로드 됩니다.</p>';
      authKeyTable += '            <p style="text-align:center; font-weight:600; font-size:20px; color:#ff6863">';
      authKeyTable += '             현재 데이터수(중복포함) : <span style="color:#ea0000; font-weight:bold">'+Number(self.excelTotalCnt).toLocaleString()+'</span>';
      authKeyTable += '            </p>';
      authKeyTable += '        </dd>';
      authKeyTable += '    </dl>';
      authKeyTable += '    <section class="container_join" style="margin:0px; padding:0px">';
      authKeyTable += '       <h2 style="border-top:4px solid #222; padding-top:20px"></h2>';
      authKeyTable += '       <dl style="padding:0px 10px">';
      var viewcodename = '';
      if(self.viewTypes == 'VIEW'){
        viewcodename = '조회';
      }else if(self.viewTypes == 'DOWNLOAD'){
        viewcodename = '다운로드';
      }else if(self.viewTypes == 'RATING'){
        viewcodename = '평점';
      }
      authKeyTable += '         <dt style="width:35%; font-size:20px">조회 구분</dt>';
      authKeyTable += '         <dd style="width:65%; font-size:17px">'+viewcodename+'</dd>';
      authKeyTable += '         <dt style="width:35%; font-size:20px">검색된 기간</dt>';
      authKeyTable += '         <dd style="width:65%; font-size:17px">'+(self.queryParams.day_code != 'dayall' ? self.queryParams.start_date+' ~ '+self.queryParams.end_date : '전체')+'</dd>';
      authKeyTable += '       </dl>';
      authKeyTable += '    </section>';
      authKeyTable += '</section>';

      swal.fire({
        title: '엑셀다운로드!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: authKeyTable,
        type: 'warning',
        showConfirmButton: true,
        // onOpen: function (){
        //
        // },
        confirmButtonColor: '#ff500f',
        confirmButtonText: 'DOWNLOAD',
        onBeforeOpen: () => {
          const content = swal.getContent()
          const $ = content.querySelector.bind(content)

          // const mobileNumber = $('#mobileNumber')
          // const mobileNumberButton = $('#mobileNumberButton')
          // const userAuthKey = $('#userAuthKey')
          // const checkAuthKey = $('#checkAuthKey')
          //
          // mobileNumber.addEventListener('click', () => {
          // })
          //
          // mobileNumberButton.addEventListener('click', () => {
          //   this.pubAuthKey(mobileNumber.value);
          // })
          //
          // checkAuthKey.addEventListener('click', () => {
          //   this.checkAuthKey(userAuthKey.value);
          // })
        },
      }).then((swalResult) => {
        if (swalResult.value) {
          // console.log(self.userkeyParams);
          var resultTable = "";
          resultTable += '<table class="r-point" cellspacing="0" style="margin-top: 15px">';
          resultTable += '  <tr>';
          resultTable += '    <th width="120">총 데이터수</th>';
          resultTable += '    <td>'+Number(self.excelTotalCnt).toLocaleString()+'</td>';
          resultTable += '  </tr>';
          resultTable += '  <tr>';
          resultTable += '    <th>파일 형식</th>';
          resultTable += '    <td>.xlsx</td>';
          resultTable += '  </tr>';
          resultTable += '</table>';

          swal.fire({
            // type: 'success',
            title: '다운로드 중 ..',
            html: resultTable,
            showConfirmButton: false,
            allowOutsideClick: false,
            // timer: 2000,
            onOpen: function (){
              swal.showLoading();
              var filenames = '매출_통계';
              if(self.queryParams.day_code != 'dayall'){
                filenames += '_('+self.queryParams.start_date+' ~ '+self.queryParams.end_date+').xlsx';
              }else{
                filenames += '_전체.xlsx';
              }
              self.queryParams.excel_rtype = 'SA';
              var token = sessionStorage.getItem("myToken");
              var param = encodeURI(JSON.stringify(self.queryParams));
              var datas = new FormData();
              datas.append('objs', param);
              // data.append('fileurl', self.reportDataItems.abridgement_downlink);
              // data.append('filedowntype', "SAMPLEFILE");
              self.$http.post('/api/excel/salesExcelDownload?access_token=' + token, datas, { responseType: 'blob'})
                .then((result) => {
                  var blob = result.data;
                  if(navigator.appVersion.toString().indexOf('.NET') > 0){ //For IE
                    window.navigator.msSaveOrOpenBlob(blob, filenames);
                  }else if(navigator.userAgent.toLowerCase().indexOf('firefox') >-1){
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filenames;
                    document.body.appendChild(link);//For FireFox <a> tag event
                    //not working
                    link.click();
                  }else{
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filenames;
                    link.click();
                  }
                  swal.close();
                })
            },
          }).then(function() {
            swal.fire(
              '다운로드 완료',
              '',
              'success'
            ).then(function() {

            });
          });
        }
      })
    },
    dateMonthSelect (item) {
      var self = this;
      self.dateMonthButtons.forEach(function (el, idx, arr){
        if(el.item_code == item.item_code){
          el.state = true;
        }else{
          el.state = false;
        }
      });
      // { item_name: '전체', item_code:'dayall', state: true },
      // { item_name: '오늘', item_code:'1|days',state: false },
      // { item_name: '1주일', item_code:'7|days',state: false },
      // { item_name: '1개월', item_code:'1|months',state: false },
      // { item_name: '6개월', item_code:'6|months',state: false },
      // { item_name: '1년', item_code:'1|years',state: false },
      self.queryParams.day_code = item.item_code;
      var addDateCnt = 0;
      var dateSpilt;
      dateSpilt = item.item_code.split("|");
      self.searchOncheck();
      setTimeout(function(){
        $('input[name="daterange"]').data('daterangepicker').setStartDate(moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD'));
        $('input[name="daterange"]').data('daterangepicker').setEndDate(moment().format('YYYY-MM-DD'));
        self.queryParams.start_date = moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD');
        self.queryParams.end_date = moment().format('YYYY-MM-DD');
      }, 0);
    },
  }
}

</script>
<style lang="css" scoped>
.exceldown_button {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #1c9847; font-size:15px}
</style>
<style src="daterangepicker/daterangepicker.css">



// WEBPACK FOOTER //
// src/views/statistics/sales/SalesStatistics.vue